import React, { useState, useEffect } from 'react'
import './Overview.css'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import { NavLink } from 'react-router-dom'

//Bootstrap
import Card from 'react-bootstrap/Card'

function CalendarView(props) {
  const { pendingDocuments } = props

  const [documentsOnChosenDate, setDocumentsOnChosenDate] = useState()
  const [chosenDate, setChosenDate] = useState(new Date())

  const handleMessage = (date, event, documents) => {
    const docArray = documents.filter((doc) => doc.dueDate.toDateString() === date.toDateString())
    setDocumentsOnChosenDate(docArray.length > 0 ? docArray : [])
  }

  useEffect(() => {
    handleMessage(new Date(), null, pendingDocuments)
  }, [])

  let calendarViewMarkup =
    documentsOnChosenDate && documentsOnChosenDate.length > 0 ? (
      <>
        <Card.Subtitle className='mb-2 text-muted'>Duedate for:</Card.Subtitle>
        {documentsOnChosenDate.map((doc, index) => (
          <div key={index}>
            {index + 1}. <NavLink to={'/viewDocumentDetails/' + doc.id}>{doc.title}</NavLink>
          </div>
        ))}
      </>
    ) : (
      <Card.Subtitle className='mb-2 text-muted'>No documents due on this day</Card.Subtitle>
    )

  return (
    <div className='calendar-style'>
      <DatePicker
        selected={chosenDate}
        onChange={(date) => setChosenDate(date)}
        inline
        fixedHeight
        highlightDates={pendingDocuments.map((doc) => doc.dueDate)}
        showMonthDropdown
        useShortMonthInDropdown
        onSelect={(date, event) => handleMessage(date, event, pendingDocuments)}
      />
      <Card className='calendar-description' border='dark'>
        <Card.Body>
          <Card.Title>{chosenDate.toDateString()}</Card.Title>
          {calendarViewMarkup}
        </Card.Body>
      </Card>
    </div>
  )
}

CalendarView.propTypes = {
  pendingDocuments: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default CalendarView
